// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"3caf9ee0","274":"2e8c1256","691":"c50c245b","709":"6736e607","795":"11c955f1"}[chunkId] + ".chunk.js";
};